module.exports = new __parcel__URL__("slideLeftStartIcon.751bf40a.svg").toString();